/**
 * Hierarchical query-key factory for the odometer-change reason list
 * (SVRS-55884), matching the sibling dscNotes/stipulation factories so cache
 * invalidation stays predictable. Never write a literal key array outside this
 * module — the factory IS the schema.
 *
 * The endpoint (`GET /api/v1/workbench/odometer-change-reasons`) takes no
 * parameters and is deal-independent, so `list()` is the whole leaf: one cache
 * entry shared by every deal's Odometer Disclosure modal.
 */
export const odometerChangeReasonsKeys = {
  all: ["odometerChangeReasons"] as const,
  list: () => [...odometerChangeReasonsKeys.all, "list"] as const,
};
